import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { Can, ReactTable } from "components";
import { EditChecklistsButton } from "modules/PendingChecklistsDashboard/components";
import "modules/PendingChecklistsDashboard/components/InterventionChecklists/components/InterventionChecklistsTable/InterventionChecklistsTable.scss";

import type { InterventionPendingChecklistsGrouped } from "modules/PendingChecklistsDashboard/components/InterventionChecklists/hooks";

type InterventionsChecklistsTableProps = {
  isLoading: boolean;
  pendingChecklistsGrouped?: InterventionPendingChecklistsGrouped[];
  onOpenCreateEditInterventionChecklistsModal: (keyword: string | null) => void;
};

const columnHelper = createColumnHelper<InterventionPendingChecklistsGrouped>();

export const InterventionChecklistsTable = ({ isLoading, pendingChecklistsGrouped, onOpenCreateEditInterventionChecklistsModal }: InterventionsChecklistsTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "service",
        header: () => <span>{t("v8_intervention_title", "Intervention Title")}</span>,
        size: 230,
        cell: ({ row: { original } }) => <span>{original.keyword}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "checklist_count",
        header: () => <span>{t("v8_checklists", "Checklists")}</span>,
        size: 800,
        cell: ({ row: { original } }) => <span>{original.checklists.length}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "actions",
        size: 50,
        header: () => (
          <Can I="create" the="intervention-keywords-pending-checklist">
            <div className="add-button" onClick={() => onOpenCreateEditInterventionChecklistsModal(null)}>
              <Icon name="plus" />
            </div>
          </Can>
        ),
        cell: ({ row: { original } }) => (
          <Can I={["create", "update", "delete"]} the="intervention-keywords-pending-checklist">
            <EditChecklistsButton onClick={() => onOpenCreateEditInterventionChecklistsModal(original.keyword)} />
          </Can>
        )
      })
    ],
    [t, onOpenCreateEditInterventionChecklistsModal]
  );

  return (
    <div className="InterventionChecklistsTable">
      <ReactTable isFetching={isLoading} columns={columns} data={pendingChecklistsGrouped} />
    </div>
  );
};
